// @flow strict-local

import type {EditableGraph, ConversationNode} from 'src/types/chatbot';

import * as React from 'react';

import makeClassNameComponent, {
  type ClassNameComponent,
} from 'src/utils/makeClassNameComponent';
import {getFirstMessages} from 'src/components/conversation-builder/utils';

import {OptOutMessage} from 'src/components/conversation-builder/common.jsx';
import {useSmsContext} from 'src/components/conversation-builder/sms-context';

import css from 'src/components/conversation-builder/popover.css';


export const PadSection: ClassNameComponent<> = makeClassNameComponent(
  css.padSection,
);

export const Subsection: ClassNameComponent<> = makeClassNameComponent(
  css.subsection,
);

export function useFirstSmsMessage(
  graph: EditableGraph,
  node: ConversationNode,
): boolean {
  const isSms = useSmsContext();

  return isSms && getFirstMessages(graph).some(({id}) => node.id === id);
}

export function OptOutSuffix({
  graph,
  node,
}: {
  graph: EditableGraph,
  node: ConversationNode,
}): React.Node {
  const isSms = useSmsContext();

  if (isSms) {
    const firstMessages = getFirstMessages(graph);
    return firstMessages.some(({id}) => node.id === id) && <OptOutMessage />;
  }

  return null;
}

export const Table: ClassNameComponent<> = makeClassNameComponent(css.table);
export const TableHeader: ClassNameComponent<> = makeClassNameComponent(
  css.tableHeader,
);
export const TableTitle: ClassNameComponent<> = makeClassNameComponent(
  css.tableTitle,
);
export const ColumnGrow: ClassNameComponent<> = makeClassNameComponent(
  css.columnGrow,
);
export const ColumnValue: ClassNameComponent<> = makeClassNameComponent(
  css.columnValue,
);
export const ColumnEnabled: ClassNameComponent<> = makeClassNameComponent(
  css.columnEnabled,
);
export const TableBody: ClassNameComponent<> = makeClassNameComponent(
  css.tableBody,
);
export const TableRow: ClassNameComponent<> = makeClassNameComponent(
  css.tableRowButton,
);
export const TableRowPadded: ClassNameComponent<> = makeClassNameComponent(
  css.tableRowPadded,
);
export const TableFooter: ClassNameComponent<> = makeClassNameComponent(
  css.tableFooter,
);
